import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'frontbucket.notFoundErrorBoundary.notice',
    description: 'A notice that a not found error has occurred.',
    defaultMessage: 'Resource not found',
  },

  errorHelpMessage: {
    id: 'fronbucket.repository.notFoundState.errorHelpMessage',
    description:
      'A statement indicating that the resource has not been found and to navivigate to a different page.',
    defaultMessage:
      'Return to the {previousPageLink} or go back to your {dashboardLink}.',
  },
});
